import CircularRewardsCarousel from './CircularRewardsCarousel';

export default CircularRewardsCarousel;
